export const getInitialPageFromSearchParams = (): number | null => {
  const urlSearchParams = new URLSearchParams(window.location.search)
  const potentialPage: number | null = JSON.parse(
    urlSearchParams.get('page') || 'null',
  )

  if (typeof potentialPage === 'number') {
    return potentialPage
  }

  return null
}
export const getInitialPerPageFromSearchParams = (): number | null => {
  const urlSearchParams = new URLSearchParams(window.location.search)
  const potentialPerPage: number | null = JSON.parse(
    urlSearchParams.get('perPage') || 'null',
  )

  if (typeof potentialPerPage === 'number') {
    return potentialPerPage
  }

  return null
}

export const syncPaginationToQueryParams = ({
  perPage,
  page,
}: {
  perPage: number
  page: number
}): void => {
  const searchParams = new URLSearchParams(window.location.search)

  searchParams.set('perPage', JSON.stringify(perPage))
  searchParams.set('page', JSON.stringify(page))

  const newUrl = `${window.location.pathname}?${searchParams.toString()}`

  window.history.pushState({}, '', newUrl)
}
